import timelineApi from './../../api/timeline';
import moment from 'moment';

export default {
    namespaced: true,
    state: {
        workTimes: null,
        productTimes: null,
        selectedDate: moment.utc().subtract(1, 'days').toISOString(),

        fetchingStatus: null,
    },
    getters: {
        getWorkTimes(state) {
            return state.workTimes;
        },
        getProductTimes(state) {
            return state.productTimes;
        },
        getSelectedDate(state) {
            return state.selectedDate;
        },
        getFetchingStatus(state) {
            return state.fetchingStatus;
        },
    },
    actions: {
        fetchTimelineDetails({ commit, dispatch, state }, employeeId) {
            commit('setFetchingStatus', 'running');
            commit('setWorkTimes', null);
            commit('setProductTimes', null);

            timelineApi
                .fetchForEmployeeAndDate(
                    employeeId,
                    moment(state.selectedDate).format('YYYY-MM-DD')
                )
                .then((data) => {
                    commit('setWorkTimes', data.workTimes);
                    commit('setProductTimes', data.productTimes);
                    commit('setFetchingStatus', 'success');
                })
                .catch((e) => {
                    commit('setFetchingStatus', 'error');
                });
        },
    },
    mutations: {
        setWorkTimes(state, details) {
            state.workTimes = details;
        },
        setProductTimes(state, details) {
            state.productTimes = details;
        },
        setSelectedDate(state, date) {
            state.selectedDate = date;
        },
        setFetchingStatus(state, status) {
            state.fetchingStatus = status;
        },
    },
};

// Test date '2021-05-12'
